import Immutable from 'immutable';
import moment from "moment/moment";
import { groupBy } from '../../utils/commonutils';

const LOAD = 'payNDP/LOAD';
const LOAD_SUCCESS = 'payNDP/LOAD_SUCCESS';
const LOAD_RATES_SUCCESS = 'payNDP/LOAD_RATES_SUCCESS'
const LOAD_MOUNT_SUCCESS = 'payNDP/LOAD_MOUNT_SUCCESS'
const LOAD_REPORT_SUCCESS = 'payNDP/LOAD_REPORT_SUCCESS';
const LOAD_REPORT_FAIL = 'payNDP/LOAD_REPORT_FAIL';
const LOAD_REPORT_DETAILS_SUCCESS = 'payNDP/LOAD_REPORT_DETAILS_SUCCESS';
const LOAD_REPORT_DETAILS_FAIL = 'payNDP/LOAD_REPORT_DETAILS_FAIL';
const LOAD_BILLING_PRACTICES_SUCCESS = 'payNDP/LOAD_BILLING_PRACTICES_SUCCESS';
const LOAD_BILLING_PRACTICES_FAIL = 'payNDP/LOAD_BILLING_PRACTICES_FAIL';
const SAVE_TODAY_PRODUCTION = 'payNDP/SAVE_TODAY_PRODUCTION';
const CHANGE_INTERVAL_REQUEST_COUNT = 'payNDP/CHANGE_INTERVAL_REQUEST_COUNT';
const LOAD_FAIL = 'payNDP/LOAD_FAIL';
const SAVE_PARAMS = 'payNDP/SAVE_PARAMS';
const LOAD_DOCTOR_DAY_RATE_SUCCESS = 'payNDP/LOAD_DOCTOR_DAY_RATE_SUCCESS';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  billingData: null,
  reportData: null,
  billingParams: '',
  intervalReqCount: 0,
  todayProduction: null,
  mountDate: [],
  doctorDayRate: [],
  missingOrthoRates: {},
  showMissingOrthoRates: false,
  drBonusValues: {}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('loadErr', null)
        .set('billingData', action.res)
        .set('drBonusValues', action.drBonusValues)
        .set('reportData', null)
        .set('intervalReqCount', 0)
        .set('reportDetailsData', null)
        .set('isLoad', false);

    case LOAD_RATES_SUCCESS:
      return state
        .set('doctorDayRate', action.res)

    case LOAD_MOUNT_SUCCESS:
      return state
        .set('loadErr', null)
        .set('isLoad', false)
        .set('mountDate', action.res)

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('billingData', null)
        .set('reportData', {})
        .set('reportDetailsData', {});

    case LOAD_REPORT_SUCCESS:
      return state
        .set('loadErr', null)
        .set('reportData', action.res)
        .set('reportDetailsData', null);

    case LOAD_REPORT_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportData', null);

    case LOAD_REPORT_DETAILS_SUCCESS:
      return state
        .set('loadErr', null)
        .set('reportDetailsData', action.res);

    case LOAD_REPORT_DETAILS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportDetailsData', null);

    case SAVE_PARAMS:
      return state
        .set('billingParams', action.params);

    case LOAD_DOCTOR_DAY_RATE_SUCCESS:
      return state
        .set('missingOrthoRates', action.missingOrthoRates)
        .set('showMissingOrthoRates', action.showMissingOrthoRates)

    case CHANGE_INTERVAL_REQUEST_COUNT:
      return state
        .set('intervalReqCount', action.res);

    case SAVE_TODAY_PRODUCTION:
      return state
        .set('todayProduction', action.todayProduction);

    default:
      return state;
  }
};

export const getBillingData = (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');
  const startDate = params.startDate;
  const showArchivedTrackCodes = params.showArchivedTrackCodes ? params.showArchivedTrackCodes : false;
  const abbr = params.abbr || user?.UdaDrList?.abbr;

  if (!abbr) {
    dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
    return;
  }

  try {
    let res = await api.get(`udr/ndp/pay/${abbr}/${startDate}?showArchivedTrackCodes=${showArchivedTrackCodes}`);

    const doctor = res.doctor ?? user?.drList?.[3]?.[abbr] ?? user?.UdaDrList;
    const drBonusValues = ndpCalculationVariables(doctor, res.availablePractices);

    const showMissingOrthoRates = (drBonusValues && Object.keys(drBonusValues).length) ? true : false;
    if (res) {
      dispatch({ type: LOAD_DOCTOR_DAY_RATE_SUCCESS, showMissingOrthoRates: showMissingOrthoRates, missingOrthoRates: drBonusValues });
    }
    dispatch({ type: LOAD_SUCCESS, res: res, drBonusValues: drBonusValues });
    if (params) {
      dispatch({ type: SAVE_PARAMS, params: params })
    }

    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getMountDate = (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');
  let params = '/' + JSON.stringify(user.UdaDrList.userId);
  if (!user.UdaDrList.abbr || !user.UdaDrList.userId) {
    dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
  }

  try {
    let res = await api.get(`udr/ndp/mount${params}`);
    dispatch({ type: LOAD_MOUNT_SUCCESS, res: res });
    if (params) {
      dispatch({ type: SAVE_PARAMS, params: params })
    }

    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

const updateSubtitle = (subtitle) => {
  if (!subtitle || typeof subtitle !== 'string') return subtitle;
  let calendarNumber = subtitle.match(/\d+/g);
  calendarNumber = calendarNumber - 1;
  return subtitle.replace(/\d+/g, calendarNumber);

}

export const updateBillingData = (rowData) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  const deleteRecord = rowData;
  const typeOf = deleteRecord.typeOf.includes(',') ? deleteRecord.typeOf.split(',') : deleteRecord.typeOf.split(';');
  const PatientID = deleteRecord.PatientID;
  const ProcCode = deleteRecord.ProcCode;
  const ProcDate = deleteRecord.ProcDate;
  const scheduled = deleteRecord.scheduled;
  const practice = deleteRecord.practice;
  let billingData = getState().get('payNDP').get('billingData');
  const drBonusValues = getState().get('payNDP').get('drBonusValues');
  typeOf.forEach((type) => {
    switch (type) {
      case 'PATIENT':
      case 'PATIENT;':
        billingData.patientVisitArray = billingData.patientVisitArray.filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        if (billingData.unschedPatientVisitsByDate[ProcDate]) {
          billingData.unschedPatientVisitsByDate[ProcDate] = billingData.unschedPatientVisitsByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let calendarItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'PatientVisit' && item.scheduled === scheduled);
        calendarItem.subtitle = updateSubtitle(calendarItem.subtitle);
        calendarItem.total = calendarItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'PatientVisit' && item.scheduled === scheduled ? calendarItem : item);
        if (billingData.unschedPatientVisitsByDate[ProcDate] && billingData.unschedPatientVisitsByDate[ProcDate].length === 0) {
          delete billingData.unschedPatientVisitsByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'PatientVisit' && item.scheduled === scheduled));
        }

        const calendarDataByPractice = billingData.unschedPatientVisitsByDate && billingData.unschedPatientVisitsByDate[ProcDate]
          ? groupBy(billingData.unschedPatientVisitsByDate[ProcDate], 'practice') : {};
        if (Object.keys(calendarDataByPractice).length < 0 || calendarDataByPractice[practice] === undefined) {
          billingData.workedDays = billingData.workedDays.filter(item => !(item.date === ProcDate && item.practice === practice && item.scheduled === scheduled));
        }

        break;
      case 'S-TART':
      case 'S-TART;':
        billingData.startArray = billingData.startArray.filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        if (billingData.unschedStartByDate[ProcDate]) {
          billingData.unschedStartByDate[ProcDate] = billingData.unschedStartByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let startItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'Start' && item.scheduled === scheduled);
        startItem.subtitle = updateSubtitle(startItem.subtitle);
        startItem.total = startItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'Start' && item.scheduled === scheduled ? startItem : item);
        if (billingData.unschedStartByDate[ProcDate] && billingData.unschedStartByDate[ProcDate].length === 0) {
          delete billingData.unschedStartByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'Start' && item.scheduled === scheduled));
        }

        const calendarDataByPracticeStart = billingData.unschedStartByDate && billingData.unschedStartByDate[ProcDate]
          ? groupBy(billingData.unschedStartByDate[ProcDate], 'practice') : {};
        if (Object.keys(calendarDataByPracticeStart).length < 0 || calendarDataByPracticeStart[practice] === undefined) {
          billingData.startList = billingData.startList.filter(item => !(item.date === ProcDate && item.practice === practice && item.scheduled === scheduled));
        }
        break;
      case 'SDSTART':
      case 'SDSTART;':
        billingData.sdstartArray = billingData.sdstartArray.filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        if (billingData.unschedSdstartByDate[ProcDate]) {
          billingData.unschedSdstartByDate[ProcDate] = billingData.unschedSdstartByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let sdstartItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'SD-Start' && item.scheduled === scheduled);
        sdstartItem.subtitle = updateSubtitle(sdstartItem.subtitle);
        sdstartItem.total = sdstartItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'SD-Start' && item.scheduled === scheduled ? sdstartItem : item);
        if (billingData.unschedSdstartByDate[ProcDate] && billingData.unschedSdstartByDate[ProcDate].length === 0) {
          delete billingData.unschedSdstartByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'SD-Start' && item.scheduled === scheduled));
        }

        const calendarDataByPracticeSdstart = billingData.unschedSdstartByDate && billingData.unschedSdstartByDate[ProcDate]
          ? groupBy(billingData.unschedSdstartByDate[ProcDate], 'practice') : {};
        if (Object.keys(calendarDataByPracticeSdstart).length < 0 || calendarDataByPracticeSdstart[practice] === undefined) {
          billingData.sdstartList = billingData.sdstartList.filter(item => !(item.date === ProcDate && item.practice === practice && item.scheduled === scheduled));
        }
        break;
      case 'SDCONTRACT':
      case 'SDCONTRACT;':
        billingData.sdcontractArray = billingData.sdcontractArray.filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        if (billingData.unschedSdcontractByDate[ProcDate]) {
          billingData.unschedSdcontractByDate[ProcDate] = billingData.unschedSdcontractByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let sdcontractItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'SD-Contract' && item.scheduled === scheduled);
        sdcontractItem.subtitle = updateSubtitle(sdcontractItem.subtitle);
        sdcontractItem.total = sdcontractItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'SD-Contract' && item.scheduled === scheduled ? sdcontractItem : item);
        if (billingData.unschedSdcontractByDate[ProcDate] && billingData.unschedSdcontractByDate[ProcDate].length === 0) {
          delete billingData.unschedSdcontractByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'SD-Contract' && item.scheduled === scheduled));
        }

        const calendarDataByPracticeSdcontract = billingData.unschedSdcontractByDate && billingData.unschedSdcontractByDate[ProcDate]
          ? groupBy(billingData.unschedSdcontractByDate[ProcDate], 'practice') : {};
        if (Object.keys(calendarDataByPracticeSdcontract).length < 0 || calendarDataByPracticeSdcontract[practice] === undefined) {
          billingData.sdcontractList = billingData.sdcontractList.filter(item => !(item.date === ProcDate && item.practice === practice && item.scheduled === scheduled));
        }

        break;
      case 'DEBOND':
      case 'DEBOND;':
        if (billingData.unschedDebondByDate[ProcDate]) {
          billingData.unschedDebondByDate[ProcDate] = billingData.unschedDebondByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let debondItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'Debond' && item.scheduled === scheduled);
        debondItem.subtitle = updateSubtitle(debondItem.subtitle);
        debondItem.total = debondItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'Debond' && item.scheduled === scheduled ? debondItem : item);
        if (billingData.unschedDebondByDate[ProcDate] && billingData.unschedDebondByDate[ProcDate].length === 0) {
          delete billingData.unschedDebondByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'Debond' && item.scheduled === scheduled));
        }

        const calendarDataByPracticeDebond = billingData.unschedDebondByDate && billingData.unschedDebondByDate[ProcDate]
          ? groupBy(billingData.unschedDebondByDate[ProcDate], 'practice') : {};
        if (Object.keys(calendarDataByPracticeDebond).length < 0 || calendarDataByPracticeDebond[practice] === undefined) {
          billingData.debondList = billingData.debondList.filter(item => !(item.date === ProcDate && item.practice === practice && item.scheduled === scheduled));
        }
        break;
      case 'DOT':
      case 'DOT;':
        billingData.dotArray = billingData.dotArray.filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        if (billingData.unschedDotByDate[ProcDate]) {
          billingData.unschedDotByDate[ProcDate] = billingData.unschedDotByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let dotItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'Dot' && item.scheduled === scheduled);
        dotItem.subtitle = updateSubtitle(dotItem.subtitle);
        dotItem.total = dotItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'Dot' && item.scheduled === scheduled ? dotItem : item);
        if (billingData.unschedDotByDate[ProcDate] && billingData.unschedDotByDate[ProcDate].length === 0) {
          delete billingData.unschedDotByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'Dot' && item.scheduled === scheduled));
        }


        break;
      case 'EXAMS':
      case 'EXAMS;':
        if (billingData.unschedExamsByDate[ProcDate]) {
          billingData.unschedExamsByDate[ProcDate] = billingData.unschedExamsByDate[ProcDate].filter(item => !(item.PatientID === PatientID && item.ProcCode === ProcCode && item.ProcDate === ProcDate));
        }
        let examItem = billingData.calendarList.find(item => item.date === ProcDate && item.type === 'Exam' && item.scheduled === scheduled);
        examItem.subtitle = updateSubtitle(examItem.subtitle);
        examItem.total = examItem.total - 1;
        billingData.calendarList = billingData.calendarList.map(item => item.date === ProcDate && item.type === 'Exam' && item.scheduled === scheduled ? examItem : item);
        if (billingData.unschedExamsByDate[ProcDate] && billingData.unschedExamsByDate[ProcDate].length === 0) {
          delete billingData.unschedExamsByDate[ProcDate];
          billingData.calendarList = billingData.calendarList.filter(item => !(item.date === ProcDate && item.type === 'Exam' && item.scheduled === scheduled));
        }


        break;
    }
  });

  dispatch({ type: LOAD_SUCCESS, res: billingData, drBonusValues: drBonusValues });
};


export const sendReport = (reportObj) => async (dispatch, getState, api) => {
  reportObj.params = getState().get('payNDP').get('billingParams');
  Object.assign(reportObj, { timeStamp: moment().format('DD-MMMM-YYYY-hh:mmA') });
  try {
    let res = await api.post('udr/ndp/pay/sendReport', { data: reportObj });
    dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
  }
};

export const actionPayNDP = (doctorId, practiceId, payApproved, startDate, approvedAmount) => async (dispatch, getState, api) => {
  try {
    let res = await api.post(`udr/ndp/pay/approvePay/${doctorId}`, { data: { practiceId: practiceId, payApproved: payApproved, startDate: startDate, doctorId: doctorId, approvedAmount: approvedAmount } });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

const ndpCalculationVariables = (doctor, practices) => {
  if (!doctor) {
    return {};
  }
  const practiceMap = (practices || []).reduce((acc, practice) => {
    acc[practice.id] = practice.practice;
    return acc;
  }, {});
  const attributes = ['startBonus', 'debondBonus', 'dotBonus', 'firstStart', 'consultPay', 'consultPrice', 'sdstart', 'sdcontract', 'travelStipend'];
  const drBonusValues = {
    orthoDayRate: doctor.rates?.filter(r => !r.practiceId || practiceMap[r.practiceId])
      .map(r => ({ fieldName: 'ODR for ' + (practiceMap[r.practiceId] ?? 'All Practices'), value: r.value?.dailyRatePay })),
  }
  attributes.forEach(attr => {
    if (doctor[attr] != undefined)
      drBonusValues[attr] = doctor[attr];
  });
  return drBonusValues;
}

export const setShowMissingOrthoRates = (showMissingOrthoRates) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_DOCTOR_DAY_RATE_SUCCESS, showMissingOrthoRates: showMissingOrthoRates, missingOrthoRates: {} });
}

export const getOrthoPayData = (params = '', abbr) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');
  const startDate = params.startDate;
  const showArchivedTrackCodes = params.showArchivedTrackCodes ? params.showArchivedTrackCodes : false;

  try {
    const res = await api.get(`udr/ndp/pay/${abbr}/${startDate}?showArchivedTrackCodes=${showArchivedTrackCodes}`);
    const newDrObj = {};
    const ndpDrList = (user && user.drList && user.drList[3]) || {};
    Object.keys(ndpDrList).forEach((objItem) => {
      newDrObj[objItem.toUpperCase()] = ndpDrList[objItem];
    })

    const doctor = res.doctor || newDrObj[abbr.toUpperCase()];
    const drBonusValues = ndpCalculationVariables(doctor, res.availablePractices);
    const showMissingOrthoRates = (drBonusValues && Object.keys(drBonusValues).length) ? true : false;
    if (res) {
      dispatch({ type: LOAD_DOCTOR_DAY_RATE_SUCCESS, showMissingOrthoRates: showMissingOrthoRates, missingOrthoRates: drBonusValues });
    }
    dispatch({ type: LOAD_SUCCESS, res: res });
    if (params) {
      dispatch({ type: SAVE_PARAMS, params: params })
    }

    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

